import { Grid, TextField } from "@mui/material";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import React from "react";
import { rfc3339 } from "../../utils";
import { ru } from 'date-fns/locale';

export const DateFilter = (props: any) => {
  const { startTime, stopTime, onChange } = props;
  const [startDate, setStartDateChange] = React.useState(startTime);
  const [stopDate, setStopDateChange] = React.useState(stopTime);

  const handleStartDateChange = (date: Date) => {
    var newDate = rfc3339(date, true);
    setStartDateChange(newDate);
    handleChange(newDate, stopDate);
  };

  const handleStopDateChange = (date: Date) => {
    var newDate = rfc3339(date, true);
    setStopDateChange(newDate);
    handleChange(startDate, newDate);
  };

  const handleChange = (fStartDate, fStopDate) => {
    if (fStartDate == startDate && fStopDate == stopDate) return;
    onChange(fStartDate, fStopDate);
  };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns} locale={ru}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <DatePicker
              label="Начало периода"
              value={startDate}
              onChange={handleStartDateChange}
              renderInput={(params) => (
                <TextField {...params} variant="standard" />
              )}
              inputFormat="dd.MM.yyyy"
              maxDate={new Date()}
            />

            {/* <DatePicker
              autoOk
              label="Начало периода"
              clearable
              strictCompareDates
              value={startDate}
              emptyLabel="Выберите дату"
              onChange={handleStartDateChange}
              maxDate={new Date()}
              format="dd.MM.yyyy"
              // onAccept={handleStartDateAccept}
              // onClose={handleStartDateClose}
            /> */}
          </Grid>

          <Grid item xs={6}>
            <DatePicker
              label="Конец периода"
              value={stopDate}
              onChange={handleStopDateChange}
              renderInput={(params) => (
                <TextField {...params} variant="standard" />
              )}
              inputFormat="dd.MM.yyyy"
              minDate={startDate}
              maxDate={new Date()}
            />

            {/* <DatePicker
              autoOk
              label="Конец периода"
              clearable
              strictCompareDates
              value={stopDate}
              emptyLabel="Выберите дату"
              onChange={handleStopDateChange}
              minDate={startDate}
              maxDate={new Date()}
              format="dd.MM.yyyy"
              // onAccept={setStopDateChange}
              // onClose={handleChange}
            /> */}
          </Grid>
        </Grid>
      </LocalizationProvider>
    </>
  );
};
